import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";

const Animation = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const loadAnimation = async () => {
      try {
        const animationData = await fetch(
          "https://lottie.host/03e776af-f9d5-4a7a-86d3-93c32e28a706/9K29SFcbPo.json"
        ).then((res) => res.json());
        console.log("Animation data loaded:", animationData);

        if (containerRef.current) {
          lottie.loadAnimation({
            container: containerRef.current,
            renderer: "svg",
            loop: false,
            autoplay: true,
            animationData: animationData,
          });
        }
      } catch (error) {
        console.error("Error loading animation:", error);
      }
    };

    loadAnimation();
  }, []);

  return <div ref={containerRef} style={{ width: "100vw", height: "100vh" }} />;
};

export default Animation;
